export type RetentionPreferenceValue = 1 | 2 | 3

export type RetentionPreferenceOption = {
  label: string
  subLabel: string
  text: string
  value: RetentionPreferenceValue
}

export const RETENTION_PREFERENCE_OPTIONS: RetentionPreferenceOption[] = [
  {
    label: 'Keep it active',
    subLabel: 'Recommended. Delete anytime from your dashboard.',
    text: 'off',
    value: 1,
  },
  {
    label: 'Auto-delete after 60 days',
    subLabel: 'For most rental searches.',
    text: '60 days',
    value: 3,
  },
  {
    label: 'Auto-delete after 90 days',
    subLabel: 'For longer searches (pets, kids, specific needs).',
    text: '90 days',
    value: 2,
  },
]

export const normalizeRetentionPreference = (value?: number): RetentionPreferenceValue => {
  if (value === 60) {
    return 3
  }

  if (value === 90) {
    return 2
  }

  return value === 1 || value === 2 || value === 3 ? value : 1
}

export const getRetentionPreferenceText = (value: number): string | undefined =>
  RETENTION_PREFERENCE_OPTIONS.find((option) => option.value === value)?.text
